export const AUTH_SLICE = "auth";
export const LAYOUT_SLICE = "layout";
export const LOADING_OVERLAY_SLICE = "loadingOverlay";
